// The optional-number input pair every config form with blank-able numeric
// fields uses (PRD 14): a controlled <input type="number"> shows '' for an
// unset value, and a blank, whitespace-only or unparseable entry reads back
// as undefined rather than 0 - callers apply their own default with `??`.
export function numberField(value: number | undefined): string {
  return value === undefined ? '' : String(value)
}

export function parseOptionalNumber(raw: string): number | undefined {
  if (raw.trim().length === 0) return undefined
  const parsed = Number(raw)
  return Number.isNaN(parsed) ? undefined : parsed
}
